var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 69.5,
    cy: 69.5,
    r: 69.5,
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    transform: "translate(45.429 39.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_465",
    "data-name": "Trazado 465",
    d: "M149.256,492.091c0-.991-.688-1.582-1.9-1.582a4.21,4.21,0,0,0-1.007.1v3.181a3.818,3.818,0,0,0,.816.062C148.457,493.848,149.256,493.194,149.256,492.091Z",
    transform: "translate(-137.22 -453.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_466",
    "data-name": "Trazado 466",
    d: "M240.385,490.841a5.022,5.022,0,0,0-1.1.1v7.044a4.414,4.414,0,0,0,.847.049c2.2.016,3.643-1.2,3.643-3.77A3.089,3.089,0,0,0,240.385,490.841Z",
    transform: "translate(-220.836 -453.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_467",
    "data-name": "Trazado 467",
    d: "M88.828,123.305H64.853a6.362,6.362,0,0,0-6.353,6.353V153.15h-.62a2.56,2.56,0,0,0-2.56,2.56v15.525a2.56,2.56,0,0,0,2.56,2.56h.62v2.847A6.36,6.36,0,0,0,64.853,183H97.565a6.36,6.36,0,0,0,6.351-6.353v-38.3ZM62.036,158.512a20.058,20.058,0,0,1,3.291-.222,5.162,5.162,0,0,1,3.291.862,3.148,3.148,0,0,1,1.15,2.492,3.441,3.441,0,0,1-.99,2.556,4.993,4.993,0,0,1-3.5,1.134,6.286,6.286,0,0,1-.831-.047v3.85H62.036ZM97.565,179.1H64.853a2.464,2.464,0,0,1-2.461-2.462V173.8H92.887a2.559,2.559,0,0,0,2.56-2.56V155.71a2.56,2.56,0,0,0-2.56-2.56H62.393V129.658a2.464,2.464,0,0,1,2.461-2.459l22.519-.023V135.5a4.407,4.407,0,0,0,4.406,4.406l8.154-.023.092,36.76A2.463,2.463,0,0,1,97.565,179.1ZM71.323,169.088V158.512a21.927,21.927,0,0,1,3.291-.222,6.933,6.933,0,0,1,4.41,1.149,4.764,4.764,0,0,1,1.82,4.058,5.458,5.458,0,0,1-1.789,4.361,7.729,7.729,0,0,1-4.968,1.389A21.088,21.088,0,0,1,71.323,169.088Zm17.435-6.261v1.98H84.891v4.33H82.447V158.37h6.581v2H84.891v2.461Z",
    transform: "translate(-55.32 -123.305)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPdf);
export default __webpack_public_path__ + "static/media/ico-pdf.2aad05ae3c4b4ba9e6fa54b5c8aac1e1.svg";
export { ForwardRef as ReactComponent };